import React, { Component } from "react";
import { FiCheck } from "react-icons/fi";
import { StaticImage } from "gatsby-plugin-image";

class NewsTabs extends Component {
    render() {
        return (
            <div className="tabs-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="single-tab-content mt-4">
                                <div className="row">
                                    <div className="col-md-7 pr-5 pt-4">

                                        <p className="text-primary text-uppercase mb--0 fontWeight400" style={{"fontSize": "0.875rem"}}>
                                            Ljubljana – Litija, Saturday, June 13, 2026
                                        </p>

                                        <h3>
                                            THE MUSEUM TRAIN IS COMING TO LITIJA
                                        </h3>

                                        <p className="mb-15px fontWeight600 font-italic">
                                            Doživite Litijo drugače – z Muzejskim vlakom!
                                        </p>

                                        <p className="mb-15px">
                                            From Ljubljana, you’ll embark on an unforgettable journey through
                                            time along the railway line—all the way to Litija. A ride on the
                                            historic train offers a unique opportunity to socialize, admire
                                            the beautiful landscape, and discover the local cultural, natural,
                                            and culinary heritage. You certainly won’t expect who you might
                                            meet along the way!
                                        </p>

                                        <p className="mb-15px">
                                            After the ride on the Museum Train, carefully curated programs and
                                            experiences await you, from which you can choose the one that
                                            speaks to you most.
                                        </p>

                                        <p className="mb-15px fontWeight600">
                                            Choose your program and join us for an unforgettable day in
                                            Litija!
                                        </p>

                                        <p className="mb--0 fontWeight600">
                                            Pustolovščina med krošnjami Geossa:
                                        </p>
                                        <ul className="list-style--1">
                                            <li><FiCheck />ride on the museum train,</li>
                                            <li><FiCheck />bus transportation to Geoss Adventure Park,</li>
                                            <li><FiCheck />park admission and activities, picnic lunch.</li>
                                        </ul>

                                        <p className="mb--0 fontWeight600">
                                            Skrivnosti mineralov in narave:
                                        </p>
                                        <ul className="list-style--1">
                                            <li><FiCheck />ride on the museum train,</li>
                                            <li><FiCheck />visit to the Sitarjevec Mine and tasting of Sitarjevec mal’ca,</li>
                                            <li><FiCheck />tour of Zeleni raj Park,</li>
                                            <li><FiCheck />organized bus transportation.</li>
                                        </ul>

                                        <p className="mb--0 fontWeight600">
                                            Muzejski vlak z animacijo in lokalnimi okusi:
                                        </p>
                                        <ul className="list-style--1">
                                            <li><FiCheck />a ride on the museum train,</li>
                                            <li><FiCheck />an entertainment program featuring the elf Sitarjevček, a herbalist, and a fortune-teller,</li>
                                            <li><FiCheck />culinary treats featuring local delicacies,</li>
                                            <li><FiCheck />presentation of local stories and legends.</li>
                                        </ul>

                                        <p className="mb--0 fontWeight600">
                                            The Charcoal-Burning Heritage of Litija:
                                        </p>
                                        <ul className="list-style--1">
                                            <li><FiCheck />one-way ride on the museum train from Ljubljana to Litija,</li>
                                            <li><FiCheck />a visit to the Brinovec Charcoal-Burning Homestead with refreshments,</li>
                                            <li><FiCheck />a tour and concert at the Polymelos Museum of Antique Keyboards in Dole near Litija,</li>
                                            <li><FiCheck />organized bus transportation between locations.</li>
                                        </ul>

                                        <p className="mb--0 fontWeight600">
                                            Board the train in Ljubljana:
                                        </p>
                                        <ul className="list-style--1">
                                            <li><FiCheck />in the morning at 9:20 a.m. and</li>
                                            <li><FiCheck />in the afternoon at 1:17 p.m.</li>
                                        </ul>

                                        <p className="mb-15px">
                                            Check train departures and arrivals on the{" "}
                                            <a
                                                href="https://potniski.sz.si/vozni-redi/muzejski-vlak/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                SŽ website
                                            </a>
                                            , as well as more detailed information about the programs and
                                            pricing.
                                        </p>

                                        <p className="mb-15px fontWeight600">
                                            Organizers: TIC Litija and Slovenian Railways. See you on the
                                            museum train in Litija!
                                        </p>
                                    </div>

                                    <div className="col-md-5 flex justify-content-start align-items-start mt-3">
                                        <div className="thumb hover-slide-up">
                                            <StaticImage
                                                src="../../../assets/images/news/muzejski-vlak-2026-en.png"
                                                alt="Museum train Ljubljana – Litija"
                                                placeholder="blurred"
                                                imgClassName="img-fluid w-100"
                                                loading="lazy"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default NewsTabs;
